import React, {useState, useEffect} from 'react';
import {BeatLoader} from "react-spinners";
import {getExamReport} from "../../api/app";
import Footer from "../../components/layout/Footer";
import {truncate} from "../../utils/trunate";
import {useSelector} from "react-redux";

const ExamReport = () => {

    const [loading, setLoading] = useState(true);
    const [examReport, setExamReport] = useState(null);

    useEffect(() => {
        getExamReport().then((response) => {
            if(!response.error) {
                setExamReport(response.payload)
                setLoading(false);
            }
        })
    }, []);

    return (
        <div>
            {loading ? <div className="h-screen flex item-center justify-center">
                    <div className="loader">
                        <BeatLoader color="#003074" size={20} />
                    </div>
                </div> :
                <div className="container">
                    <div className="md:flex justify-between items-center mb-8">
                        <div>
                            <div className="text-xl font-semibold">Exam Report</div>
                            <div className="text-sm mt-2 font-medium text-gray-500 leading-6"> Every result is published for each term.</div>
                        </div>
                    </div>

                    <div className="tube-card mt-3 lg:mx-0 -mx-5">

                        <h4 className="py-3 px-5 border-b font-semibold text-grey-700">
                            <ion-icon name="star"></ion-icon> Exam
                        </h4>

                        <div className="divide-y">
                            {examReport.map((item) => {
                                return(
                                    <div className="flex md:space-x-6 space-x-3 md:p-5 p-2 relative">
                                        <a href={`#/academic/${item._id}`} className="md:w-50 md:h-50 w-20 h-20 overflow-hidden rounded-lg relative shadow-sm">
                                            <img src="https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg" className="w-12 h-12 uk-position-center" alt=""/>
                                        </a>
                                        <div className="flex-1 md:space-y-2 space-y-1">
                                            <a href={`#/academic/${item._id}`} className="md:text-xl font-semibold line-clamp-2"> {truncate(item.name, 30)} </a>
                                            <a href={`#/academic/${item._id}`} className="md:font-semibold block text-sm"> {item.grade.name}</a>
                                            <div className="flex items-center justify-between">
                                                <div className="flex space-x-2 items-center text-sm">
                                                    <div>Term {item.term}</div>
                                                </div>
                                                <a href={`${item.meta.doc.uri}`} target='_blank' className="md:flex items-center justify-center h-9 px-8 rounded-md border -mt-3.5 hidden"> View </a>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            }
            <Footer/>
        </div>
    );
};

export default ExamReport;
